import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Heart, Target, Users, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <div className="py-5">
      <Container>
        {/* Hero Section */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3">About FURRMAA</h1>
          <p className="lead text-muted">Your trusted partner in pet care since 2020</p>
        </div>

        {/* Mission Section */}
        <Row className="mb-5">
          <Col lg={6} className="mb-4 mb-lg-0">
            <img 
              src="https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=800" 
              alt="Happy pets"
              className="w-100 rounded-3 shadow"
              style={{ height: '400px', objectFit: 'cover' }}
            />
          </Col>
          <Col lg={6} className="d-flex flex-column justify-content-center">
            <h2 className="fw-bold mb-4">Our Mission</h2>
            <p className="text-muted mb-3">
              At FURRMAA, we believe that every pet deserves the best care, nutrition, and love. Our mission is to make premium pet products accessible to all pet parents while providing expert guidance and support.
            </p>
            <p className="text-muted mb-3">
              We carefully curate our product selection to ensure that everything we offer meets the highest standards of quality and safety. From nutritious food to engaging toys, we're here to support your pet's health and happiness.
            </p>
            <p className="text-muted">
              Join thousands of satisfied pet parents who trust FURRMAA for all their pet care needs.
            </p>
          </Col>
        </Row>

        {/* Values Section */}
        <div className="mb-5">
          <h2 className="fw-bold text-center mb-5">Our Values</h2>
          <Row className="g-4">
            <Col md={6} lg={3}>
              <Card className="text-center border-0 shadow-sm h-100 p-4">
                <div className="d-flex justify-content-center mb-3">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: '#FFE5E5' 
                    }}
                  >
                    <Heart size={40} style={{ color: '#FF6B6B' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-3">Compassion</h5>
                <p className="text-muted small">
                  We care deeply about the wellbeing of all animals and treat every pet as if they were our own.
                </p>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="text-center border-0 shadow-sm h-100 p-4">
                <div className="d-flex justify-content-center mb-3">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: '#E3F2FD' 
                    }}
                  >
                    <Target size={40} style={{ color: '#2196F3' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-3">Quality</h5>
                <p className="text-muted small">
                  We never compromise on quality and only offer products we would use for our own pets.
                </p>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="text-center border-0 shadow-sm h-100 p-4">
                <div className="d-flex justify-content-center mb-3">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: '#F3E5F5' 
                    }}
                  >
                    <Users size={40} style={{ color: '#9C27B0' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-3">Community</h5>
                <p className="text-muted small">
                  We're building a community of pet lovers who support and learn from each other.
                </p>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="text-center border-0 shadow-sm h-100 p-4">
                <div className="d-flex justify-content-center mb-3">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '80px', 
                      height: '80px', 
                      backgroundColor: '#E8F5E9' 
                    }}
                  >
                    <TrendingUp size={40} style={{ color: '#4CAF50' }} />
                  </div>
                </div>
                <h5 className="fw-bold mb-3">Innovation</h5>
                <p className="text-muted small">
                  We continuously improve and innovate to provide the best shopping experience.
                </p>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Stats Section */}
        <div className="bg-light rounded-3 p-5 text-center">
          <Row>
            <Col md={3} sm={6} className="mb-4 mb-md-0">
              <h2 className="fw-bold" style={{ color: '#a5cb89' }}>10K+</h2>
              <p className="text-muted mb-0">Happy Customers</p>
            </Col>
            <Col md={3} sm={6} className="mb-4 mb-md-0">
              <h2 className="fw-bold" style={{ color: '#a5cb89' }}>500+</h2>
              <p className="text-muted mb-0">Products</p>
            </Col>
            <Col md={3} sm={6} className="mb-4 mb-md-0">
              <h2 className="fw-bold" style={{ color: '#a5cb89' }}>50+</h2>
              <p className="text-muted mb-0">Brands</p>
            </Col>
            <Col md={3} sm={6}>
              <h2 className="fw-bold" style={{ color: '#a5cb89' }}>4.9</h2>
              <p className="text-muted mb-0">Average Rating</p>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default About;